import requests from 'utils/requests';

const fetchStats = async () => {
  const data = await requests.get('/dashboard/');
  return data.json();
};

export default { fetchStats };
